import { AgenciaBancaria } from './../_classes/agencia-bancaria';
import { ModalAlertaService } from './../shared/modal-alerta.service';
import { ServidorService } from './../_servicos/servidor.service';
import { take } from 'rxjs/operators';
import { Observable, Subject, timer } from 'rxjs';
import { RestService } from './../_servicos/rest.service';
import { ContaPessoal } from './../_classes/conta-pessoal';
import { Component, OnInit } from '@angular/core';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-conta-pessoal',
  templateUrl: './conta-pessoal.component.html',
  styleUrls: ['./conta-pessoal.component.scss'],
})
export class ContaPessoalComponent implements OnInit {
  private readonly recurso: string = 'conta-pessoal'; //mesmo que a rota
  carregando = false;

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  urlImagem = '';
  erros$ = new Subject<boolean>();
  contaPessoal$: Observable<ContaPessoal>;
  contaPessoal: ContaPessoal;

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private env: EnvService
  ) {
    this.carregando = true;
  }

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
    this.carregando = false;
  }*/

  executarAoCarregar(x: ContaPessoal) {
    this.contaPessoal = x;
    ////console.log('2');
    this.urlImagem = this.imagemBanco(x.agencia);
    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.contaPessoal$ = this.service
      .getContaCorrente(this.env.servidor.idServidor)
      .pipe(take(1));
    this.contaPessoal$.subscribe((a) => this.executarAoCarregar(a));
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }

  imagemBanco(r: AgenciaBancaria) {
    let resultado = 'bank_building_128px.png';
    if (r) {
      if (r.banco) {
        if (
          [1, 33, 77, 104, 237, 260, 290, 341, 399, 746, 748, 756].find(
            (nr) => nr === r.banco.nrCodigoBanco
          )
        ) {
          resultado = r.banco.nrCodigoBanco + '.png';
        }
      }
    }
    return './assets/imagens/bancos/' + resultado;
  }
}
